import { render, staticRenderFns } from "./kbdjs.vue?vue&type=template&id=f3d5d2a6"
import script from "./kbdjs.vue?vue&type=script&lang=js"
export * from "./kbdjs.vue?vue&type=script&lang=js"
import style0 from "./kbdjs.vue?vue&type=style&index=0&id=f3d5d2a6&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports